export default __webpack_public_path__ + "static/media/P-034.a2ffeed1.png";